export default __webpack_public_path__ + "static/media/quiz.19a9a916.png";